import React from 'react';
import Icon from './Icon';
import { gradientFor } from '../theme/tokens';
import './AppIcon.css';

/**
 * The glossy rounded app-tile icon. `app` is a registry entry; `size` controls
 * the tile edge in px. Accent gradient comes from the app's accent or category.
 */
export default function AppIcon({ app, size = 56, radius }) {
  const accent = app?.accent || app?.category || 'system';
  const glyph = Math.round(size * 0.46);
  return (
    <span
      className="hive-appicon"
      style={{
        width: size,
        height: size,
        borderRadius: radius != null ? radius : Math.round(size * 0.32),
        background: gradientFor(accent),
      }}
    >
      <Icon name={app?.icon} size={glyph} color="#ffffff" strokeWidth={2.2} />
    </span>
  );
}
